import { jsx as _jsx } from "react/jsx-runtime";
const Madden25Wordmark = ({ height, width, className }) => {
    return (_jsx("img", { src: "/img/games/sports/madden_nfl/madden-25/madden-25-full.png", height: height, width: width, className: className }));
};
export default Madden25Wordmark;
